(function () {
  var instances = {};
  var pendingInits = {};

  function initFlavorCardCarousel(sectionId) {
    var el = document.getElementById('fc-carousel-' + sectionId);
    if (!el) return;

    var track = el.querySelector('[data-fc-track]');
    if (!track) return;

    if (instances[sectionId]) {
      instances[sectionId].destroy();
      delete instances[sectionId];
    }

    // Queried only after any prior instance's clones have been torn down above,
    // so a re-init never mistakes leftover clones for real items.
    var originalItems = Array.prototype.slice.call(track.querySelectorAll('[data-fc-item]'));
    if (!originalItems.length) return;

    var sectionEl = el.closest('.section-resource-list');
    var root = sectionEl || el.parentElement;
    var arrowsGroup = root.querySelector('[data-fc-arrows]');
    var btnPrev = root.querySelector('[data-fc-prev="' + sectionId + '"]');
    var btnNext = root.querySelector('[data-fc-next="' + sectionId + '"]');

    var count = originalItems.length;

    function step() {
      var item = originalItems[0];
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return item ? item.offsetWidth + gap : track.clientWidth;
    }

    // Read before the clone-building writes below (not after) to avoid forcing a
    // synchronous reflow: a real item's width is fixed by CSS (flex: 0 0 325px)
    // and unaffected by how many clone siblings later join it, so it's safe to
    // measure here first rather than re-querying layout once the DOM is dirty.
    var realSetWidth = step() * count;

    // With only a handful of real products against a viewport wide enough to show
    // several at once, clones are routinely fully visible during normal navigation
    // near the loop boundary - not just a brief edge peek - so they need to stay
    // genuinely clickable (matching the real card they're a pixel-identical copy
    // of) rather than being inert. cloneNode(true) carries every `id` over
    // verbatim though, including the Destini widget host's
    // `id="destini-locator-..."` - an id-based lookup elsewhere on the page could
    // resolve to a hidden clone instead of the real card, so ids are stripped
    // (the click handler in flavor-card-carousel-destini-widget.liquid only reads
    // data-apo off this element by class, never by id, so it still works
    // correctly on a clone once the id is gone).
    function stripIds(node) {
      if (node.removeAttribute) node.removeAttribute('id');
      var idNodes = node.querySelectorAll ? node.querySelectorAll('[id]') : [];
      for (var n = 0; n < idNodes.length; n++) idNodes[n].removeAttribute('id');
    }

    // One extra set before, one after - enough buffer for a single swipe/button
    // step to never run out of clones, without the old 3x-set overhead.
    for (var i = count - 1; i >= 0; i--) {
      var cloneBefore = originalItems[i].cloneNode(true);
      cloneBefore.setAttribute('aria-hidden', 'true');
      stripIds(cloneBefore);
      track.insertBefore(cloneBefore, track.firstChild);
    }
    originalItems.forEach(function (item) {
      var cloneAfter = item.cloneNode(true);
      cloneAfter.setAttribute('aria-hidden', 'true');
      stripIds(cloneAfter);
      track.appendChild(cloneAfter);
    });

    // Arrows stay visible even when every real card already fits on screen: the
    // track is still natively scrollable (it's wrapped in clone sets before/after
    // the real items), so prev/next remain functional and looped for consistency
    // even without overflow. (Centering the track via CSS in that case would
    // block scrolling into the leading clone set in most browsers, breaking that
    // loop, so the track is intentionally left flex-start-aligned regardless of
    // fit, and arrows are simply always shown.)
    function updateArrows() {
      if (!arrowsGroup) return;
      arrowsGroup.hidden = false;
    }

    // Start scrolled to the beginning of the real (middle) set.
    track.scrollLeft = realSetWidth;

    // Detecting "scrolled into a clone" by element visibility doesn't work once
    // more than one item is visible at a time (the common case) - a boundary
    // clone can become mostly visible well before the user has actually
    // scrolled past the real set, and correcting at that point can immediately
    // make the *other* boundary visible too, ping-ponging forever. Checking
    // scrollLeft numerically - and only once scrolling has actually settled,
    // never mid-animation - avoids that entirely. Reading scrollLeft here isn't
    // paired with a preceding style/DOM write, so it doesn't force a reflow.
    function normalizeScroll() {
      var sl = track.scrollLeft;
      if (sl < realSetWidth - step() / 2) {
        track.scrollLeft = sl + realSetWidth;
      } else if (sl >= realSetWidth * 2 - step() / 2) {
        track.scrollLeft = sl - realSetWidth;
      }
    }

    var scrollEndTimer = 0;
    function onScroll() {
      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(normalizeScroll, 120);
    }

    var usesNativeScrollEnd = 'onscrollend' in window;
    if (usesNativeScrollEnd) {
      track.addEventListener('scrollend', normalizeScroll);
    } else {
      track.addEventListener('scroll', onScroll, { passive: true });
    }

    function prev() {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    }

    function next() {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    }

    if (btnPrev) btnPrev.addEventListener('click', prev);
    if (btnNext) btnNext.addEventListener('click', next);

    var resizeObserver = new ResizeObserver(function () {
      // Item width (and therefore realSetWidth) can change across the mobile/
      // desktop breakpoint - recompute and re-normalize position to the
      // equivalent spot in the (possibly resized) real set.
      var indexInSet = Math.round((track.scrollLeft - realSetWidth) / step());
      realSetWidth = step() * count;
      track.scrollLeft = realSetWidth + indexInSet * step();
      updateArrows();
    });
    resizeObserver.observe(track);

    updateArrows();

    instances[sectionId] = {
      destroy: function () {
        if (btnPrev) btnPrev.removeEventListener('click', prev);
        if (btnNext) btnNext.removeEventListener('click', next);
        if (usesNativeScrollEnd) {
          track.removeEventListener('scrollend', normalizeScroll);
        } else {
          track.removeEventListener('scroll', onScroll);
          window.clearTimeout(scrollEndTimer);
        }
        resizeObserver.disconnect();
        Array.prototype.slice
          .call(track.querySelectorAll('[data-fc-item][aria-hidden="true"]'))
          .forEach(function (node) {
            node.remove();
          });
      },
    };
  }

  // A page can carry several of these carousels at once (eg. the homepage's two
  // go-full-flavor sections plus its Featured collection). Scheduling every
  // instance on the same flat delay makes them all fire in one contiguous burst
  // - each doing DOM cloning, layout reads, and ResizeObserver setup with no gap
  // between them - which reads as a single long main-thread task. requestIdleCallback
  // lets the browser interleave this work with rendering instead; setTimeout is
  // only the fallback for browsers without it.
  var scheduleCallback =
    window.requestIdleCallback || function (fn) { return window.setTimeout(fn, 50); };

  function scheduleInit(sectionId) {
    if (pendingInits[sectionId]) return;
    pendingInits[sectionId] = scheduleCallback(function () {
      delete pendingInits[sectionId];
      initFlavorCardCarousel(sectionId);
    });
  }

  function initAllCarousels() {
    document.querySelectorAll('[id^="fc-carousel-"]').forEach(function (carousel) {
      var sectionId = carousel.id.replace('fc-carousel-', '');
      var root = carousel.closest('[data-has-recommendations]');
      if (root && root.dataset.hasRecommendations !== 'true') return;
      scheduleInit(sectionId);
    });
  }

  function watchRecommendations() {
    document.querySelectorAll('product-recommendations').forEach(function (rec) {
      if (rec.dataset.fcWatched === 'true') return;
      rec.dataset.fcWatched = 'true';

      var observer = new MutationObserver(function (mutations) {
        if (rec.classList.contains('hidden')) return;

        var shouldInit = mutations.some(function (mutation) {
          return (
            mutation.type === 'attributes' &&
            (mutation.attributeName === 'data-recommendations-performed' ||
              mutation.attributeName === 'data-has-recommendations' ||
              mutation.attributeName === 'class')
          );
        });
        if (!shouldInit) return;

        var carousel = rec.querySelector('[id^="fc-carousel-"]');
        if (!carousel) return;

        var contentRoot = rec.querySelector('[data-has-recommendations="true"]');
        if (!contentRoot) return;

        scheduleInit(carousel.id.replace('fc-carousel-', ''));
      });

      observer.observe(rec, {
        attributes: true,
        attributeFilter: ['data-recommendations-performed', 'data-has-recommendations', 'class'],
        subtree: true,
      });
    });
  }

  window.initFlavorCardCarousel = initFlavorCardCarousel;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllCarousels();
      watchRecommendations();
    });
  } else {
    initAllCarousels();
    watchRecommendations();
  }
})();
